import React from 'react';
import { Box, Card, CardContent, Stack, Typography, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useSnackbar } from 'notistack';
const LANG_KEY = 'app_language';
export default function LanguageTab(props) {
    const { enqueueSnackbar } = useSnackbar();
    const initial = (localStorage.getItem(LANG_KEY) || 'ru');
    const [language, setLanguage] = React.useState(initial);
    const handleSave = () => {
        var _a;
        localStorage.setItem(LANG_KEY, language);
        enqueueSnackbar('Язык сохранён', { variant: 'success', autoHideDuration: 1500 });
        (_a = props.onSaved) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    const disabled = language === initial;
    return (React.createElement(Card, { variant: "outlined", sx: { borderRadius: 2, maxWidth: 600 } },
        React.createElement(CardContent, { sx: { p: 3 } },
            React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { mb: 2.5 } },
                React.createElement(LanguageIcon, { fontSize: "small", color: "action" }),
                React.createElement(Typography, { variant: "subtitle1", fontWeight: 700 }, "\u042F\u0437\u044B\u043A \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430")),
            React.createElement(Stack, { spacing: 2.5 },
                React.createElement(FormControl, { variant: "filled", fullWidth: true },
                    React.createElement(InputLabel, { id: "language-select-label" }, "\u042F\u0437\u044B\u043A"),
                    React.createElement(Select, { labelId: "language-select-label", value: language, label: "\u042F\u0437\u044B\u043A", onChange: (e) => setLanguage(e.target.value) },
                        React.createElement(MenuItem, { value: "ru" }, "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"),
                        React.createElement(MenuItem, { value: "en" }, "English"))),
                React.createElement(Box, null,
                    React.createElement(Button, { variant: "contained", color: "success", disabled: disabled, onClick: handleSave }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"))))));
}
